/**
 * @surfline/quiver-react v12.14.9 2020-10-22
 */

const FEET = 'FT';
const HAWAIIAN = 'HI';
// these units can potentially be grouped by imperial/metric as well

export { FEET, HAWAIIAN };
//# sourceMappingURL=units.js.map
